/* global google, pinCampaignModalStrings */
import { modal } from '../global.js';
import { utils } from '../../pin-campaign/utils.js';

class AddressValidation {
  constructor() {
    this.input = document.getElementById('search-address');

    this.state = {
      enabled: !!this.input,
      addressFieldsVisible: false,
    };

    if (!this.state.enabled) {
      return;
    }

    this.button = document.querySelector('#search-address__submit');

    this.autocomplete = new google.maps.places.Autocomplete(this.input, {
      componentRestrictions: { country: 'ca' },
      fields: ['address_components'],
      types: ['address'],
    });

    this.initEventListeners();

    this.cache = {
      address1: document.getElementById('address1'),
      address2: document.getElementById('address2'),
      city: document.getElementById('city'),
      country: document.getElementById('country'),
      province: document.getElementById('province'),
      zip: document.getElementById('zip'),
    };

    this.userAddress = {
      province: 'AB', // Set initial value now that we are using a dropdown. Will need to change if the first choice is ever not Alberta
    };

    // Initializers
    this.updateUserAddress();
  }

  cacheUserAddress(place) {
    // reset user address
    this.userAddress = {};

    const addressComponents = place.address_components;

    // Break down all the objects we need.
    const streetNumber = addressComponents.filter((place) =>
      place.types.includes('street_number')
    );

    const streetName = addressComponents.filter((place) =>
      place.types.includes('route')
    );

    const address2 = addressComponents.filter((place) =>
      place.types.includes('subpremise')
    );

    const city = addressComponents.filter(
      (place) =>
        place.types.includes('locality') && place.types.includes('political')
    );

    const country = addressComponents.filter((place) =>
      place.types.includes('country')
    );

    const province = addressComponents.filter((place) =>
      place.types.includes('administrative_area_level_1')
    );

    const zip = addressComponents.filter((place) =>
      place.types.includes('postal_code')
    );

    // If objects exist, cache them.

    // Init this property so that the combined strings work.
    this.userAddress.address1 = '';

    // Relates to the following, in checkout: name="checkout[shipping_address][address1]"
    if (streetNumber.length) {
      this.userAddress.address1 = streetNumber[0].long_name;
    }
    if (streetNumber.length && streetName.length) {
      this.userAddress.address1 += ' ';
    }
    if (streetName.length) {
      this.userAddress.address1 += streetName[0].long_name;
    }

    // Relates to the following, in checkout: name="checkout[shipping_address][address2]"
    if (address2.length) {
      this.userAddress.address2 = address2[0].long_name;
    }

    // Relates to the following, in checkout: name="checkout[shipping_address][city]"
    if (city.length) {
      this.userAddress.city = city[0].long_name;
    }

    // Relates to the following, in checkout: name="checkout[shipping_address][country]"
    if (country.length) {
      this.userAddress.country = country[0].long_name;
    }

    // Relates to the following, in checkout: name="checkout[shipping_address][province]"
    if (province.length) {
      this.userAddress.province = province[0].short_name;
    }

    // Relates to the following, in checkout: name="checkout[shipping_address][zip]"
    if (zip.length) {
      this.userAddress.zip = zip[0].long_name;
    }
  }

  storeUserAddress() {
    localStorage.userAddress = JSON.stringify(this.userAddress);
  }

  updateUserAddress() {
    // Update this.userAddress every time a field is changed
    for (const field in this.cache) {
      this.cache[field].addEventListener('change', () => {
        this.userAddress[field] = this.cache[field].value.trim();
      });
    }
  }

  updateAddressFields() {
    // Update the fields by pulling from this.userAddress
    for (const field in this.cache) {
      this.cache[field].value = this.userAddress[field]
        ? this.userAddress[field]
        : '';
    }
  }

  initEventListeners() {
    this.input.addEventListener('keypress', (e) => {
      if (e.code === 'Enter') {
        // Prevent the form from submitting when interacting with the search address field
        e.preventDefault();
      }
    });

    this.button.addEventListener('click', () => {
      const place = this.autocomplete.getPlace();

      if (!place || !place.address_components) {
        // User entered the name of a Place that was not suggested and pressed the Enter key, or the Place Details request failed.
        modal.updateMessage(pinCampaignModalStrings.strings.addressNotFound);
        modal.open();

        return;
      }

      this.cacheUserAddress(place);
      this.updateAddressFields();
    });
  }
}

const addressValidation = utils.hasHouseholdLimit()
  ? new AddressValidation()
  : null;

export default addressValidation;
